var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.6666V15.4166M4.16663 16.6666V15.4166",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 12.5C1.66663 11.7234 1.66663 11.3351 1.79349 11.0289C1.96265 10.6205 2.28711 10.296 2.69549 10.1269C3.00177 10 3.39006 10 4.16663 10H15.8333C16.6099 10 16.9981 10 17.3044 10.1269C17.7128 10.296 18.0373 10.6205 18.2064 11.0289C18.3333 11.3351 18.3333 11.7234 18.3333 12.5C18.3333 13.2766 18.3333 13.6649 18.2064 13.9711C18.0373 14.3795 17.7128 14.704 17.3044 14.8731C16.9981 15 16.6099 15 15.8333 15H4.16663C3.39006 15 3.00177 15 2.69549 14.8731C2.28711 14.704 1.96265 14.3795 1.79349 13.9711C1.66663 13.6649 1.66663 13.2766 1.66663 12.5Z",
    stroke: "#111111",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 6.85734 17.5 5.286 16.5237 4.30968C15.5474 3.33337 13.976 3.33337 10.8333 3.33337H9.16667C6.02397 3.33337 4.45262 3.33337 3.47631 4.30968C2.5 5.286 2.5 6.85734 2.5 10",
    stroke: "#111111",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 9.99996V8.74996C15.4167 7.17861 15.4167 6.39294 14.9286 5.90478C14.4404 5.41663 13.6547 5.41663 12.0834 5.41663H7.91671C6.34536 5.41663 5.55968 5.41663 5.07153 5.90478C4.58337 6.39294 4.58337 7.17861 4.58337 8.74996V9.99996",
    stroke: "#111111",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83337V10",
    stroke: "#111111",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.4b9739a6a41aceec654d0997d8b6cc52.svg";
export { ForwardRef as ReactComponent };